export default __webpack_public_path__ + "static/media/video.0640a41b.png";